module.exports = __webpack_public_path__ + "img/thumb_Songs for Robots.6ba788e3.jpg";